var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boolean-wrapper"},[(_vm.showButton)?_c('v-btn',{staticClass:"align-self-center",attrs:{"text":"","medium":""},on:{"click":_vm.onDeleteEmployeeButtonClick}},[_c('v-icon',[_vm._v("remove_circle")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }